export default "__VITE_ASSET__De7ZMIB8__"